/**
 * Reveal-on-scroll.
 *
 * Elements marked `.reveal` start faded and offset (see base.css) and get
 * `.is-visible` the first time they enter the viewport. Each element is
 * unobserved once revealed — this only ever runs one way.
 *
 * Ported from the inline IIFE in ../foamico-main/index.html. Two additions the
 * original didn't need: a rescan on `shopify:section:load` so sections
 * re-rendered in the theme editor still animate, and a guard for browsers
 * without IntersectionObserver.
 *
 * Under prefers-reduced-motion nothing is observed; base.css forces `.reveal`
 * elements visible so no content is ever hidden.
 */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  if (!('IntersectionObserver' in window)) {
    for (const el of document.querySelectorAll('.reveal')) el.classList.add('is-visible');
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    },
    { threshold: 0.15 }
  );

  const scan = (root = document) => {
    for (const el of root.querySelectorAll('.reveal:not(.is-visible)')) observer.observe(el);
  };

  scan();

  // The theme editor replaces a section's markup wholesale on every edit.
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
